import { ISolitaire } from "./solitaire";

export class ResultBody<TSolitaire extends ISolitaire> {
    result: boolean;
    constructor(result: boolean) {
        this.result = result;
    }
}